import React from "react"
import Layout from "@layouts/Layout"
import { Container, Row, Col } from "react-bootstrap"
import Image from "@src/utils/image"
import ContactForm from "@components/ContactForm"
import { FaMapPin, FaMailBulk, FaWhatsapp } from "react-icons/fa"
import SEO from "../components/SEO"

const contact = () => {
  return (
    <Layout transparent>
      <SEO title="Contact" />
      <section id="contact">
        <Image
          id="2PFqQPYI8UFL9TM2DQY21M"
          background
          style={{
            paddingTop: "75px",
          }}
          className="contact-image"
          overlay="rgba(0,0,0,0.3)"
        >
          <Container className="py-6 py-md-8">
            <Row className="justify-content-center">
              <Col
                className=" p-4 rounded"
                style={{ backgroundColor: "rgba(255,255,255,0.85)" }}
                lg={8}
              >
                <h1 className="text-center pb-3">
                  Let’s talk about how we can get you to{" "}
                  <u>where you want to be.</u>
                </h1>
                <ContactForm />
              </Col>
            </Row>
          </Container>
        </Image>
      </section>

      <section className="py-6 py-md-8 text-center bg-white">
        <Container>
          <h1 className="text-center mb-5">More contact details:</h1>
          <Row>
            <Col lg={4}>
              <FaWhatsapp size="3em" className="text-powder mb-4" />
              <a href="tel:+27 72 948 0341" className="d-block">
                <u>+27 72 948 0341</u>
              </a>
            </Col>
            <Col lg={4}>
              <FaMapPin size="3em" className="text-powder mb-4" />
              <p>
                Rynfield Benoni 1509, <br />
                Gauteng, <br />
                South Africa
              </p>
            </Col>
            <Col lg={4}>
              <FaMailBulk size="3em" className="text-powder mb-4" />
              <a href="mailto:info@refiloeradebe.com" className="d-block">
                <u>info@refiloeradebe.com</u>
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export default contact
